import { tap } from 'rxjs/operators';
import { State, Action, StateContext, Selector } from '@ngxs/store';

import { AuthStateModel, SetUserInfo, AuthToken, CleanToken } from './auth.actions';

import { from } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import jwtDecode from 'jwt-decode';

@State<AuthStateModel>({
  name: 'auth',
  defaults: {
    email: '',
    name: '',
    roles: [],
    token: '',
    attributes: [],
  },
})
@Injectable()
export class AuthState {
  @Selector()
  static token(state: AuthStateModel) {
    return state.token;
  }

  constructor(private _authService: AuthService) {}

  @Action(SetUserInfo)
  setUserInfo({ patchState }: StateContext<AuthStateModel>, { payload }: SetUserInfo) {
    patchState({
      ...payload,
    });
  }

  @Action(AuthToken)
  authToken({ patchState }: StateContext<AuthStateModel>, { payload }: AuthToken) {
    return this._authService.authToken(payload).pipe(
      tap((res: any) => {
        const decodedToken: any = jwtDecode(res.accessToken);
        const roles = decodedToken.realm_access.roles.map((role: string) => role.toLowerCase());
        patchState({
          token: res.accessToken,
          name: decodedToken.name,
          roles: [...new Set<string>(roles)],
          attributes: decodedToken.group_profile_attributes,
        });
      })
    );
  }

  @Action(CleanToken)
  cleanToken({ patchState }: StateContext<AuthStateModel>) {
    patchState({
      token: '',
      name: '',
      roles: [],
    });
  }
}
